import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy, limit, startAfter,} from "firebase/firestore";
import { db } from "../firebase-config";
import { useNavigate } from "react-router-dom";

export default function UseCases() {
    const [useCases, setUseCases] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchUseCases() {
            const snap = await getDocs(collection(db, "useCases"));
            const data = snap.docs.map(doc => ({
                id: doc.id,
                ... doc.data()
            }));
            setUseCases(data);
        }

        fetchUseCases();
    }, []);

  return (
    <div className="useCasesContainer">
      <h1>Use Cases</h1>

      <div className="useCasesGrid">
        {useCases.map(uc => (
          <div
            key={uc.id}
            className="useCaseCard"
            onClick={() => navigate(`/useCases/${uc.id}`)}
          >
            <h2>{uc.title || uc.id}</h2>
            <p>{uc.description || "Click to explore this use case"}</p>
          </div>
        ))}
      </div>
    </div>
  );
}